import { lazy } from 'react'
import { Briefcase, Clock, CreditCard, FileText, KeyRound, ShieldCheck, Users } from 'lucide-react'
import { hasModule } from '../access/modules.js'
import { isAdmin } from '../admin/utils/isAdmin.js'

/**
 * Sous-pages de « Compte ». `visible(user)` décide de l'affichage (droits, organisation).
 * Chaque écran est une page existante, chargée à la demande.
 */
export const ACCOUNT_SECTIONS = [
  {
    key: 'credits',
    label: 'Crédits',
    icon: CreditCard,
    visible: () => true,
    component: lazy(() => import('../../pages/BuyCredits.jsx')),
  },
  {
    key: 'activite',
    label: 'Activités',
    icon: Clock,
    visible: () => true,
    component: lazy(() => import('../../pages/ActivityHistory.jsx')),
  },
  {
    // Comptes externes utilisés par JLP (LinkedIn…) ; la liste des services dépend des droits.
    key: 'authentification',
    label: 'Authentification',
    icon: KeyRound,
    visible: () => true,
    component: lazy(() => import('./pages/AuthenticationPage.jsx')),
  },
  {
    // Sociétés au nom desquelles on vend (dont les agences des projets auto) : bloc « Prestataire »
    // des contrats et clé Pennylane qui émet devis et factures.
    key: 'entreprise',
    label: 'Entreprises',
    icon: Briefcase,
    visible: () => true,
    component: lazy(() => import('./pages/MyCompanyPage.jsx')),
  },
  {
    // Modèles de documents de l'organisation : spécifications, messages de réponse… (agent des projets auto).
    key: 'modeles',
    label: 'Modèles',
    icon: FileText,
    visible: () => true,
    component: lazy(() => import('./pages/TemplatesPage.jsx')),
  },
  {
    key: 'organisation',
    label: 'Organisation',
    icon: Users,
    visible: (user) => Boolean(user?.organization),
    component: lazy(() => import('../../pages/Organization.jsx')),
  },
  {
    key: 'admin',
    label: 'Administration',
    icon: ShieldCheck,
    visible: (user) => isAdmin(user),
    component: lazy(() => import('../admin/pages/AdminPage.jsx')),
  },
]
